import React, { useMemo } from "react";
import { ACTIVE } from "../../../enums/statusEnums";
import { INITIAL_GET_PARAMS } from "../../../enums/generalEnums";
import { useCollabCreators } from "../../../hooks/apiHooks/useCollabCreators";
import { arrayRandomizer } from "../../../helpers/arrayHelper";
import { TopCreatorsLayout } from "./TopCreatorsLayout";

export const TagsSection = (props) => {
  const {
    handleViewAll,
    tag,
    lazyLoad = false
  } = props;

  const MAX_CARD_PER_ROW = 8;
  const { data: creators, isLoading } = useCollabCreators(tag?.name, { ...INITIAL_GET_PARAMS, per_page: 20, status: ACTIVE, user_id: tag?.user_ids });

  const renderCreators = useMemo(() => {
    const currentList = creators?.data;
    return arrayRandomizer(currentList, MAX_CARD_PER_ROW);
  }, [creators]);

  return (
    <TopCreatorsLayout
      creators={renderCreators}
      isLoading={isLoading}
      handleViewAll={() => handleViewAll()}
      tagName={tag?.name}
      lazyLoad={lazyLoad}
    />
  );
};